import { MESSAGE_STATUS, MESSAGE_TYPE } from './enums.js';

// 是否普通消息
let isNormal = function (type) {
	return type >= 0 && type < 10;
}

// 是否状态消息
let isStatus = function (type) {
	return type >= 10 && type < 20;
}

// 是否提示消息
let isTip = function (type) {
	return type >= 20 && type < 30;
}

// 操作交互类消息
let isAction = function (type) {
	return type >= 40 && type < 50;
}

// 多人通话信令
let isRtcGroup = function (type) {
	return type >= 200 && type < 300;
}


// 群内系统提示：新人进群、邀请、设管理员等（撤回/封禁提示保留）
let isGroupOpTip = function (msg) {
	if (!msg || msg.type != MESSAGE_TYPE.TIP_TEXT) {
		return false;
	}
	if (msg.status == MESSAGE_STATUS.RECALL) {
		return false;
	}
	const content = String(msg.content || '');
	if (content.indexOf('撤回了一条消息') >= 0) {
		return false;
	}
	if (content.indexOf('已被管理员封禁') >= 0 || content.indexOf('本群聊已被管理员封禁') >= 0) {
		return false;
	}
	if (msg.groupId) {
		return true;
	}
	return /欢迎加入|邀请.{0,30}(加入|进群)|加入群|进群|退出群|被移出|踢出群|设为管理员|设置管理员|取消管理员|移除.{0,20}管理员/.test(content);
}

export {
	isAction, isGroupOpTip, isNormal, isRtcGroup, isStatus, isTip
};

